import { forwardRef } from "react";

import { Editor } from "@shared/components/DataEntry";

import { FormField } from "../FormField";
import { FormEditorProps } from "../../types";

export const FormEditor = forwardRef<HTMLInputElement, FormEditorProps>(({ name, ...props }, ref) => (
  <FormField name={name}>
    <Editor ref={ref} name={name} {...props} />
  </FormField>
));

FormEditor.displayName = "Form.Editor";
